import { http } from '@/lib/http';
import * as Sentry from '@sentry/react';

export const axiosBaseQuery =
  () =>
  async ({ url, method = 'get', params = null, data = null }) => {
    try {
      const config = {};
      if (method === 'get') {
        config.url = url;
        config.method = 'get';
        config.params = params;
      } else if (
        method === 'post' ||
        method === 'put' ||
        method === 'delete' ||
        method === 'patch'
      ) {
        config.url = url;
        config.method = method;
        config.params = params;
        config.data = data;
      }
      const result = await http(config);

      /**
       *  @author - Raja
       *  This is a hack to deliver vouch to gojek. Need to talk to BE and fix this after launch.
       */
      if (url === '/vouch/new') {
        return {
          data: { ...result?.data?.ats_job, error: result?.errors },
        };
      }

      const checkOutreachesActivate = (str) => {
        const regex = /\/outreaches\/\d+\/activate/;
        return regex.test(str);
      };

      if (checkOutreachesActivate(url)) {
        return {
          error: { errors: result?.errors, status: result?.status },
        };
      }

      // Note - Error messages need to be structured.
      if (
        result?.errors?.length > 0 ||
        (result?.errors && Object.keys(result?.errors)?.length > 0)
      ) {
        return {
          error: result?.errors,
        };
      }
      return {
        data: {
          data: result?.data,
          meta: result?.meta,
        },
      };
    } catch (err) {
      Sentry.captureMessage('http-redux-query-error', (scope) => {
        scope.addBreadcrumb({
          data: {
            error: err,
          },
          level: 'info',
        });
      });
      return {
        // A failed request must always produce a truthy error: a 5xx with an
        // empty body left `data` undefined, so callers saw neither data nor
        // error and reported success.
        error: err?.response?.data || {
          status: err?.response?.status,
          message: err?.message || 'Request failed',
        },
      };
    }
  };
